import * as reactiveUtils from "@arcgis/core/core/reactiveUtils.js";

export const getFeatureZoom = (urlParams) => {
  let mapViewSettings = [-114.83479406614642, 55.581467716870236, 5];

  if (urlParams != null) {
    mapViewSettings = [urlParams.lon, urlParams.lat, 7];
    window.history.pushState({}, document.title, "/");
    return mapViewSettings;

  } else {
    window.history.pushState({}, document.title, "/");
    return mapViewSettings;
  }
};

export const highlightFeaturePopup = (view, layer, field, fieldId) => {
  view.whenLayerView(layer).then((layerView) => {
    reactiveUtils.watch(
      () => layerView.updating,
      (updating) => {
        if (!updating) {
          layerView.queryFeatures({
            outFields: layerView.availableFields,
            where: buildQueryString(field, fieldId),
          })
            .then((results) => {
              const graphics = results.features;

              if (graphics.length > 0) {
                const attributes = graphics[0].attributes;
                layerView.highlight(graphics);

                view.openPopup({
                  features: graphics,
                  location: {
                    latitude: attributes.latitude,
                    longitude: attributes.longitude,
                  },
                });
              }
            })
            .catch((error) => {
              console.error("Query failed:", error);
            });
        }
      }
    );
  });
};

let highlight;

export const setupOnClickEvents = async (view, eventLayer, queryField, queryLayer) => {
    try {
        const layerView = await view.whenLayerView(eventLayer);
        const opts = { include: eventLayer };

        view.on("click", async (event) => {
            try {
                const response = await view.hitTest(event, opts);
                if (response.results.length) {
                    const graphic = response.results[0].graphic;
                    const attributeValue = graphic.attributes[queryField];

                    await highlightQueryResults(view, queryLayer, queryField, attributeValue);
                } else {
                    highlight?.remove();
                }
            } catch (error) {
                console.error("hitTest failed:", error);
            }
        });
    } catch (error) {
        console.error(`Error initializing layer view for ${eventLayer.title}:`, error);
    }
};

const highlightQueryResults = async (view, queryLayer, queryField, attributeValue) => {
    try {
        const layerView = await view.whenLayerView(queryLayer);
        const queryStr = buildQueryString(queryField, attributeValue);

        const results = await layerView.queryFeatures({
            outFields: layerView.availableFields,
            where: queryStr
        });

        const graphics = results.features;
        if (graphics.length > 0) {
            highlight?.remove();
            highlight = layerView.highlight(graphics);
        }
    } catch (error) {
        console.error("query failed:", error);
    }
};

const buildQueryString = (queryField, attributeValue) => {
    return `${queryField} = ${typeof attributeValue === 'string' ? `'${attributeValue}'` : attributeValue}`;
};